// Simple wrapper to expose ready function for use in block js files

import { iterate, ready } from 'formstone/utils';

let _siteReady = false;
let _mapsReady = false;
let _mapsReadyCallbacks = [];
let _laxReady = false;
let _laxReadyCallbacks = [];

//

window.SiteReady = (cb) => {
  // console.log(cb);
  ready(() => {
    console.log('Site Ready');

    _siteReady = true;

    cb(jQuery);
  });
};

//

window.MapsReady = function(cb) {
  // Push to maps ready if nothing is ready
  if (!_mapsReady && !_siteReady) {
    _mapsReadyCallbacks.push(cb);
  } else {
    cb(jQuery);
  }
}

window.initializeGMaps = function() {
  console.log('Maps Ready');

  _mapsReady = true;

  if (!_siteReady) {
    // Push to site ready if GMaps loads first
    window.SiteReady(initMaps);
  } else {
    initMaps();
  }
}

function initMaps() {
  iterate(_mapsReadyCallbacks, (cb) => {
    cb(jQuery);
  });
}

//

window.LaxReady = function(cb) {
  // Push to lax ready if nothing is ready
  if (!_laxReady && !_siteReady) {
    _laxReadyCallbacks.push(cb);
  } else {
    cb(jQuery);
  }
}

window.initializeLax = function() {
  console.log('Lax Ready');

  _laxReady = true;

  if (!_siteReady) {
    // Push to site ready if lax loads first
    window.SiteReady(initLax);
  } else {
    initLax();
  }
}

function initLax() {
  iterate(_laxReadyCallbacks, (cb) => {
    cb(jQuery);
  });
}